"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AudioLevel;
(function (AudioLevel) {
    AudioLevel["SILENT"] = "silent";
    AudioLevel["LOW"] = "low";
    AudioLevel["HIGH"] = "high";
})(AudioLevel = exports.AudioLevel || (exports.AudioLevel = {}));
var MediaAggregationType;
(function (MediaAggregationType) {
    MediaAggregationType["NONE"] = "NONE";
    MediaAggregationType["COMPOSITE"] = "COMPOSITE";
})(MediaAggregationType = exports.MediaAggregationType || (exports.MediaAggregationType = {}));
var MediaType;
(function (MediaType) {
    MediaType["AUDIO"] = "AUDIO";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["APPLICATION"] = "APPLICATION";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
class BandwidthRtcError extends Error {
}
exports.BandwidthRtcError = BandwidthRtcError;
//# sourceMappingURL=types.js.map